module.exports = __webpack_public_path__ + "static/media/friends_activity_2.5a91801f.svg";